// LLM generated - Model Claude 4 Sonnet
import { createStyles } from '@mantine/core';

interface StyleParams {
  isCommissioner?: boolean;
}

export const useStyles = createStyles((theme, { isCommissioner }: StyleParams) => ({
  postContainer: {
    backgroundColor: theme.white,
    borderRadius: theme.radius.md, // Match Figma's 8px border radius
    padding: theme.other.spacing._16, // 16px padding as per Figma
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._12, // 12px gap between sections as per Figma
  },

  pinnedLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._4, // 4px gap between icon and text as per Figma
    marginBottom: 0, // Remove margin, handled by container gap
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._12, // 12px gap as per Figma
    justifyContent: 'flex-end', // Right align for dropdown positioning
    marginBottom: 0, // Remove margin, handled by container gap
  },

  avatarContainer: {
    position: 'relative',
    flexShrink: 0,
  },

  commissionerBadge: {
    position: 'absolute',
    bottom: -4,
    right: -4,
    width: 20,
    height: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
      display: 'block',
    },
  },

  headerContent: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
  },

  userInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._8,
    marginBottom: theme.other.spacing._4,
  },

  handle: {
    color: theme.colors.gray2[6], // #1A1C1E as per Figma
    fontSize: 14,
    fontWeight: 600, // Semi Bold as per Figma
    lineHeight: '22px', // 22px line height as per Figma
  },

  timestamp: {
    color: theme.colors.gray2[4], // #909296 as per Figma
    fontSize: 12,
    fontWeight: 500, // Medium as per Figma
    lineHeight: '18px', // 18px line height as per Figma
  },

  title: {
    color: theme.colors.gray2[6], // #1A1C1E as per Figma
    fontSize: 16,
    fontWeight: 600, // Semi Bold as per Figma
    lineHeight: '24px', // 24px line height as per Figma
    marginBottom: 0, // Remove margin, handled by container gap
    wordBreak: 'break-word',
  },

  content: {
    color: theme.colors.gray2[6], // #1A1C1E for content text as per Figma
    fontSize: 14,
    fontWeight: 400, // Regular as per Figma
    lineHeight: '20px', // 20px line height as per Figma
    marginBottom: 0, // Remove margin, handled by container gap
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap',
  },

  contentCollapsed: {
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },

  showMoreContainer: {
    marginBottom: 0, // Remove margin, handled by container gap
  },

  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: 0, // Remove margin, handled by container gap
  },

  reactionContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._4,
  },

  reactionCount: {
    color: theme.colors.gray2[3],
    fontSize: 12,
    fontWeight: 500,
  },

  menuButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 24,
    height: 24,
    cursor: 'pointer',
    borderRadius: theme.radius.sm,
    padding: 0,
    border: 'none',
    background: 'transparent',
  },
}));
